"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _solarReact = require("@solar/solar-react");

var _styles = require("@material-ui/core/styles");

var _CustomJsonForms = _interopRequireDefault(require("./CustomJsonForms"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      width: '100%',
      flexGrow: 1,
      alignItems: 'stretch'
    }
  };
});

var DataForm = function DataForm(_ref) {
  var formJSON = _ref.formJSON,
      formUIJSON = _ref.formUIJSON,
      data = _ref.data,
      onChange = _ref.onChange,
      classes = _ref.classes;
  var c = useStyles({
    classes: classes
  });
  return /*#__PURE__*/_react["default"].createElement(_solarReact.ResponsiveSheet, {
    maxWidth: 1024,
    classes: {
      root: c.root
    }
  }, /*#__PURE__*/_react["default"].createElement(_CustomJsonForms["default"], {
    schema: formJSON,
    uischema: formUIJSON,
    data: data,
    onChange: onChange
  }));
};

var _default = DataForm;
exports["default"] = _default;